import { makeTokenStore } from './tokenStorage';

// 「管理者コード」トークン：30分の短命セッションなので、タブを閉じたら消えるsessionStorageに保存する。
const store = makeTokenStore(sessionStorage, 'gj_kanri_code_token');

export const saveKanriCodeToken = store.save;
export const clearKanriCodeToken = store.clear;
export const getStoredKanriCodeToken = store.get;
